import * as home from "./home";
import * as member from "./member";
import * as system from "./system";
import * as order from "./order";
import * as product from "./product";
import * as bonus from "./bonus";
import * as config from "./config";
import * as log from "./log";
import * as report from "./report";

export default {
  ...home,
  ...member,
  ...system,
  ...order,
  ...product,
  ...bonus,
  ...config,
  ...log,
  ...report,
};
